import CPSBuyerForecast from "./Buyer/CPSBuyerForecast";
import CPSBuyerRoleForecast from "./BuyerRole/CPSBuyerRoleForecast";
import GlobalViewerForecast from "./GlobalViewer/GlobalViewerForecast";
import RegionalPlannerForecast from "./RegionalPlanner/RegionalPlannerForecast";
import RegionalViewerForecast from "./RegionalViewer/RegionalViewerForecast";
import CPSSupplierForecast from "./Supplier/CPSSupplierForecast";

const ForecastCollabCPS = () => {
    const roleDetails = localStorage.getItem("userRole");

    const roleComponentMap = {
        "Supplier Planner": CPSSupplierForecast,
        "Supplier Admin": CPSSupplierForecast,
        "App Admin": CPSBuyerForecast,
        "Global Planner": CPSBuyerRoleForecast,
        "Regional Planner": RegionalPlannerForecast,
        "Global Viewer": GlobalViewerForecast,
        "Regional Viewer": RegionalViewerForecast,
    };

    const SelectedComponent = roleComponentMap[roleDetails];

    return (
        <div style={{ marginTop: "20px" }}>
            {SelectedComponent ? <SelectedComponent /> : null}
        </div>
    );
};

export default ForecastCollabCPS;
